export namespace JobSiteRequest {

    export class Type {
        ID: string;
        Code: string;
        Name: string;
    }

    export class TaxCode {
        ID: string;
        Name: string;
        Rate: number;
        IsDirty: boolean;
        ModifyDate: Date;
    }

    export class TaxGroup {
        ID: string;
        Name: string;
        Description: string;
        Code?: any;
        IsActive: boolean;
        TaxCodes: TaxCode[];
        IsDeleted: boolean;
        MappingID: string;
        MappingCode: string;
        Rate: number;
        IsDirty: boolean;
        ModifyDate: Date;
    }

    export class Type2 {
        ID: string;
        Code: string;
        Name: string;
    }

    export class PhoneNumber {
        PhoneNumber: string;
        Type: Type2;
        Description: string;
        IsUsedForSMS: boolean;
        ID: string;
        IsDirty: boolean;
        ModifyDate: Date;
    }

    export class Contact {
        IsPrimary: boolean;
        FirstName: string;
        LastName: string;
        PhoneNumbers: PhoneNumber[];
        Emails: any[];
        ID: string;
        IsDirty: boolean;
        ModifyDate: Date;
    }

    export class ExternalAttachment {
        ID: string;
        IsDirty: boolean;
    }
    export class ExternalAttachment2 {
        ID: string;
        ExternalUrl: string;
        AttachmentPath: string;
        FileName: string;
    }

    export class Attachment {
        ID: string;
        IsDirty: boolean;
        IsDefaultImage: boolean;
        ExternalAttachment: ExternalAttachment;
        ExternalAttachment2 : ExternalAttachment2;
        FileName: string;
        FilePath: string;
        Description: string;
    }

    export class JobSiteAttachment {
        SiteID: string;
        IsActive: boolean;
        Type: Type;
        FirstName: string;
        LastName: string;
        CompanyName?: any;
        DisplayName: string;
        StreetNo: string;
        Unit: string;
        City: string;
        State: string;
        ZipCode: string;
        Comment: string;
        IsAddressVerified: boolean;
        ServiceArea?: any;
        TaxGroup: TaxGroup;
        SiteClass?: any;
        IsAllowedOnTablet: boolean;
        Contacts: Contact[];
        Customer?: any;
        Latitude: number;
        Longitude: number;
        JobsiteSince: Date;
        IntegrationStatus?: any;
        Attachments: Attachment[];
        IsDefault: boolean;
        NextWorkTicketNo?: any;
        NextWorkTicketDate?: any;
        ID: string;
        IsDirty: boolean;
        ModifyDate: Date;
    }

}

